import { useMemo } from "react";

import { GetProjectDetailsResponse } from "../../../../../../service/publicquery";
import { getComponentPropertiesByDataPath, getValueByDataPath, hasStandardSpecificData } from "../../../../../../utils";
import { ComponentProperties } from "../../../../../developer/activities";
import { StandardSpecificDefinition } from "../../../../../shared/projects/project/overview/components/StandardSpecificSection/types";

interface UseOverviewComponentReturnData {
  carbonImpactType: ComponentProperties | undefined;
  carbonImpactValue: number;
}

export const useOverviewComponent = (
  projectDetails: GetProjectDetailsResponse | undefined,
  standardSpecificDefinition: StandardSpecificDefinition
): UseOverviewComponentReturnData => {
  // No standard projects have empty standardSpecificData ("{}"), so there is no standard-specific carbon impact KPI.
  const hasData = hasStandardSpecificData(projectDetails?.standardSpecificData);

  const carbonImpactType = useMemo(
    () =>
      hasData
        ? getComponentPropertiesByDataPath(standardSpecificDefinition, standardSpecificDefinition.carbonImpactPath)
        : undefined,
    [standardSpecificDefinition, hasData]
  );

  const carbonImpactValue = useMemo(
    () =>
      hasData
        ? getValueByDataPath(projectDetails?.standardSpecificData, standardSpecificDefinition.carbonImpactPath)
        : undefined,
    [projectDetails, standardSpecificDefinition, hasData]
  );

  return {
    carbonImpactType,
    carbonImpactValue,
  };
};
